import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - DRAWER ||============================== //

/** Shell lateral (referência elevenlabs.io): mais escuro que o conteúdo, só borda, sem blur/sombra. */
export default function Drawer(theme: Theme) {
  const border = theme.palette.mode === 'light' ? '#E0E0E0' : theme.palette.divider;
  const shellBg = theme.palette.mode === 'light' ? '#F5F5F5' : theme.palette.grey[100];

  const paperBorder =
    theme.direction === 'rtl'
      ? { borderLeft: `1px solid ${border}`, borderRight: 'none' }
      : { borderRight: `1px solid ${border}`, borderLeft: 'none' };

  return {
    MuiDrawer: {
      defaultProps: {
        PaperProps: {
          elevation: 0
        }
      },
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
            backgroundColor: 'rgba(0,0,0,.95)',
            border: 'none !important'
          }
        },
        paper: {
          backgroundImage: 'none !important',
          backgroundColor: `${shellBg} !important`,
          borderRadius: 0,
          boxShadow: 'none !important',
          borderTop: 'none',
          borderBottom: 'none',
          ...paperBorder,
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none'
        }
      }
    }
  };
}
